import { Problem, ProblemDetectionContext, ProblemSeverity, ProblemType } from '../types';

export const detectFlowModuleFailures = (context: ProblemDetectionContext, generateId: () => string): Problem[] => {
  const problems: Problem[] = [];

  if (!context.flowLogs || context.flowLogs.length === 0) {
    return problems;
  }

  context.flowLogs.forEach((event, index) => {
    // Check if module execution failed or produced error results
    const hasError =
      event.Results?.toLowerCase().includes('error') ||
      event.Results?.toLowerCase().includes('failed') ||
      event.Results?.toLowerCase().includes('exception');

    if (hasError) {
      problems.push({
        id: generateId(),
        type: ProblemType.FLOW_MODULE_FAILURE,
        severity: ProblemSeverity.HIGH,
        title: `${event.ContactFlowModuleType} Module Failure`,
        description: `Module ${event.ContactFlowModuleType} failed with result: ${event.Results}`,
        timestamp: event.Timestamp,
        source: 'FLOW_LOG',
        relatedData: {
          moduleType: event.ContactFlowModuleType,
          identifier: event.Identifier,
          contactFlowName: event.ContactFlowName,
          parameters: event.Parameters,
          results: event.Results
        },
        suggestions: [
          'Check module configuration and parameters',
          'Review error logs for detailed failure information',
          'Verify required resources are available'
        ],
        index
      });
    }

    const modulesThatShouldHaveResults = ['GetUserInput', 'TransferToAgent'];

    if (
      modulesThatShouldHaveResults.includes(event.ContactFlowModuleType) &&
      (!event.Results || event.Results.trim() === '')
    ) {
      problems.push({
        id: generateId(),
        type: ProblemType.MISSING_FLOW_RESULTS,
        severity: ProblemSeverity.MEDIUM,
        title: `Missing Results for ${event.ContactFlowModuleType}`,
        description: `Module ${event.ContactFlowModuleType} completed without expected results`,
        timestamp: event.Timestamp,
        source: 'FLOW_LOG',
        relatedData: {
          moduleType: event.ContactFlowModuleType,
          identifier: event.Identifier,
          contactFlowName: event.ContactFlowName,
          parameters: event.Parameters
        },
        suggestions: [
          'Verify module is configured to capture results',
          'Check if the operation completed successfully',
          'Review module logic and expected outputs'
        ],
        index
      });
    }
  });

  return problems;
};
